import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Ubuntu Fonts
import  "./Components/Fonts/Ubuntu_fonts/Ubuntu-Bold.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-BoldItalic.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-Italic.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-Light.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-LightItalic.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-Medium.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-MediumItalic.ttf"
import "./Components/Fonts/Ubuntu_fonts/Ubuntu-Regular.ttf"
// Sharp Sans Fonts
import "./Components/Fonts/Sharp_Sans_fonts/Sharp Sans.otf"
// Circular std Fonts
import "./Components/Fonts/Circular_std_fonts/circular-std-medium-500.ttf"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
